import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './RelatedCases.less';

export class RelatedCases extends Component {
  renderRow = (relCase) => {
    const leadLink = `/filings/${relCase.case_uuid}-`;
    return (
      <tr key={relCase.case_uuid}>
        <td>
          <a href={leadLink}>
            <span>
              { relCase.case_no || '' }
            </span>
          </a>
          &nbsp; &nbsp;
          { relCase.case_title }
        </td>
        <td>{ relCase.start_date }</td>
        <td>{ relCase.end_date }</td>
      </tr>
    );
  }

  render() {
    const { relatedCases } = this.props;

    if (relatedCases.empty) {
      return (<div />);
    }

    return (
      <div className="related-cases">
        <h2 className="case-label"></h2>
          <table className="sticky-enabled tablesorter">
            <thead>
              <tr>
                <th><span>Related Cases</span></th>
                <th><span>Start Date</span></th>
                <th><span>End Date</span></th>
              </tr>
            </thead>
            <tbody>
              { relatedCases.map(this.renderRow) }
            </tbody>
          </table>
      </div>
    );
  }
}

export default RelatedCases;



/** WEBPACK FOOTER **
 ** ./src/components/case/associated_cases/RelatedCases.js
 **/